var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relevant-HSC---Added-Subjects",
    transform: "translate(-634.000000, -373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ATAR-Note",
    transform: "translate(632.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Info",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,17.6046512 C4.25581395,17.6046512 0.395348837,13.744186 0.395348837,9 C0.395348837,4.25581395 4.25581395,0.395348837 9,0.395348837 C13.744186,0.395348837 17.6046512,4.25581395 17.6046512,9 C17.6046512,13.744186 13.744186,17.6046512 9,17.6046512",
    fill: "#394049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6.90697674 C8.60465116,6.90697674 8.30232558,7.20930233 8.30232558,7.60465116 L8.30232558,12.9534884 C8.30232558,13.3488372 8.60465116,13.6511628 9,13.6511628 C9.39534884,13.6511628 9.69767442,13.3488372 9.69767442,12.9534884 L9.69767442,7.60465116 C9.69767442,7.20930233 9.39534884,6.90697674 9,6.90697674",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4.34883721 C8.48837209,4.34883721 8.06976744,4.76744186 8.06976744,5.27906977 C8.06976744,5.79069767 8.48837209,6.20930233 9,6.20930233 C9.51162791,6.20930233 9.93023256,5.79069767 9.93023256,5.27906977 C9.93023256,4.76744186 9.51162791,4.34883721 9,4.34883721",
    id: "Fill-5",
    fill: "#FFFFFF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/Icon-Info.017a6c7133c1cc8c13b16be219b8d7ea.svg";
export { ForwardRef as ReactComponent };